module.exports = __webpack_public_path__ + "static/media/XD.9bffbd6c.svg";